
define('template!portalOrdersTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="orders-card">\n  <div class="orders-card__head">\n    <span class="orders-card__title">\n      ' +
((__t = ( _.i18n('portalOrders.title', null, 'Orders with this supplier') )) == null ? '' : __t) +
'\n    </span>\n\n    <div class="orders-card__filter">\n      <button type="button" class="btn btn-sm js-scope ' +
((__t = ( scope === 'open' ? 'is-on' : '' )) == null ? '' : __t) +
'" data-scope="open">\n        ' +
((__t = ( _.i18n('portalOrders.open', null, 'In progress') )) == null ? '' : __t) +
'\n      </button>\n      <button type="button" class="btn btn-sm js-scope ' +
((__t = ( scope === 'closed' ? 'is-on' : '' )) == null ? '' : __t) +
'" data-scope="closed">\n        ' +
((__t = ( _.i18n('portalOrders.closed', null, 'Closed') )) == null ? '' : __t) +
'\n      </button>\n      <button type="button" class="btn btn-sm js-scope ' +
((__t = ( scope === 'all' ? 'is-on' : '' )) == null ? '' : __t) +
'" data-scope="all">\n        ' +
((__t = ( _.i18n('portalOrders.all', null, 'All') )) == null ? '' : __t) +
'\n      </button>\n    </div>\n  </div>\n\n  ';
 if (failed) { ;
__p += '\n    <p class="orders-card__warning">\n      ' +
((__t = ( _.i18n('portalOrders.failed', null, 'Could not read this supplier\'s orders.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } else if (empty) { ;
__p += '\n    <p class="orders-card__empty">\n      ';
 if (scope === 'open') { ;
__p += '\n        ' +
((__t = ( _.i18n('portalOrders.noneOpen', null, 'Nothing is waiting on this supplier.') )) == null ? '' : __t) +
'\n      ';
 } else if (scope === 'closed') { ;
__p += '\n        ' +
((__t = ( _.i18n('portalOrders.noneClosed', null, 'No order of this supplier has been closed yet.') )) == null ? '' : __t) +
'\n      ';
 } else { ;
__p += '\n        ' +
((__t = ( _.i18n('portalOrders.none', null, 'This supplier has never received an order through the portal.') )) == null ? '' : __t) +
'\n      ';
 } ;
__p += '\n    </p>\n  ';
 } else { ;
__p += '\n    <table class="orders-table">\n      <thead>\n        <tr>\n          <th>' +
((__t = ( _.i18n('portalOrders.order', null, 'Order') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalOrders.product', null, 'Product') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalOrders.quantity', null, 'Qty') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalOrders.status', null, 'Status') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalOrders.received', null, 'Received') )) == null ? '' : __t) +
'</th>\n          <th>' +
((__t = ( _.i18n('portalOrders.delivery', null, 'Delivery') )) == null ? '' : __t) +
'</th>\n          <th></th>\n        </tr>\n      </thead>\n      <tbody>\n        ';
 _.each(orders, function (order) { ;
__p += '\n          <tr class="orders-row">\n            <td>\n              <span class="orders-row__poi">' +
((__t = ( order.purchaseOrderId )) == null ? '' : __t) +
'</span>\n              ';
 if (order.reference) { ;
__p += '\n                <span class="orders-row__muted">' +
((__t = ( order.reference )) == null ? '' : __t) +
'</span>\n              ';
 } ;
__p += '\n              ';
 if (order.express) { ;
__p += '\n                <span class="pill pill--warn">' +
((__t = ( _.i18n('portalOrders.express', null, 'express') )) == null ? '' : __t) +
'</span>\n              ';
 } ;
__p += '\n              ';
 if (order.sample) { ;
__p += '\n                <span class="pill pill--quiet">' +
((__t = ( _.i18n('portalOrders.sample', null, 'sample') )) == null ? '' : __t) +
'</span>\n              ';
 } ;
__p += '\n            </td>\n\n            <td>\n              <span class="orders-row__code">' +
((__t = ( order.productCode )) == null ? '' : __t) +
'</span>\n              <span class="orders-row__muted">' +
((__t = ( order.productName )) == null ? '' : __t) +
'</span>\n            </td>\n\n            <td class="num">' +
((__t = ( order.quantity )) == null ? '' : __t) +
'</td>\n\n            <td>\n              <span class="pill status-' +
((__t = ( order.status )) == null ? '' : __t) +
'">' +
((__t = ( order.statusLabel )) == null ? '' : __t) +
'</span>\n              ';
 if (order.neverViewed) { ;
__p += '\n                <span class="pill pill--warn"\n                      title="' +
((__t = ( _.i18n('portalOrders.neverViewedHint', null,
                        'Sent to the portal, but nobody at this supplier has opened it yet.') )) == null ? '' : __t) +
'">\n                  ' +
((__t = ( _.i18n('portalOrders.neverViewed', null, 'unopened') )) == null ? '' : __t) +
'\n                </span>\n              ';
 } ;
__p += '\n            </td>\n\n            <td>' +
((__t = ( order.received || '—' )) == null ? '' : __t) +
'</td>\n\n            <td class="' +
((__t = ( order.late ? 'orders-row__late' : '' )) == null ? '' : __t) +
'">\n              ' +
((__t = ( order.delivery || '—' )) == null ? '' : __t) +
'\n            </td>\n\n            <td class="orders-row__actions">\n              <button type="button" class="btn btn-sm js-conversation" data-secid="' +
__e( order.secId ) +
'">\n                ' +
((__t = ( _.i18n('portalMessages.open', null, 'Messages') )) == null ? '' : __t) +
'\n                ';
 if (order.unreadMessages > 0) { ;
__p += '\n                  <span class="pill pill--message">' +
((__t = ( order.unreadMessages )) == null ? '' : __t) +
'</span>\n                ';
 } ;
__p += '\n              </button>\n            </td>\n          </tr>\n        ';
 }); ;
__p += '\n      </tbody>\n    </table>\n\n    ';
 if (paged) { ;
__p += '\n      <div class="orders-pager">\n        <span class="orders-pager__count">\n          ' +
((__t = ( first )) == null ? '' : __t) +
'–' +
((__t = ( last )) == null ? '' : __t) +
' ' +
((__t = ( _.i18n('portalOrders.of', null, 'of') )) == null ? '' : __t) +
' ' +
((__t = ( total )) == null ? '' : __t) +
'\n        </span>\n        <button type="button" class="btn btn-sm js-page" data-step="previous"\n                ' +
((__t = ( hasPrevious ? '' : 'disabled' )) == null ? '' : __t) +
'>\n          ' +
((__t = ( _.i18n('portalOrders.previous', null, 'Previous') )) == null ? '' : __t) +
'\n        </button>\n        <button type="button" class="btn btn-sm js-page" data-step="next"\n                ' +
((__t = ( hasNext ? '' : 'disabled' )) == null ? '' : __t) +
'>\n          ' +
((__t = ( _.i18n('portalOrders.next', null, 'Next') )) == null ? '' : __t) +
'\n        </button>\n      </div>\n    ';
 } ;
__p += '\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

